<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/weblog/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission180"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateNewPost") }}
            </router-link>
            <div class="fleft">
              <router-link
                :to="{ path: '/weblog/PostCategory/Index' }"
                class="vs-component vs-button bg_l_blue mr-4"
                v-has-permission="permission183"
              >
                <feather-icon
                  icon="BookIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("PostCategories") }}
              </router-link>
              <router-link
                :to="{ path: '/weblog/Tags/Index' }"
                class="vs-component vs-button bg_purple mr-4"
                v-has-permission="permission184"
              >
                <feather-icon icon="TagIcon" svgClasses="h-4 w-4" class="ico" />
                {{ $t("Tags") }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title'), sort: 'Title' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('IsActive') },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 24%">
                  {{ row.title }}
                </td>
                <td style="width: 24%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 24%">
                  <vs-checkbox v-model="row.isActive" :disabled="true">{{
                    $t("Active")
                  }}</vs-checkbox>
                </td>
                <td style="width: 24%">
                  <router-link :to="{ path: '/weblog/Modify/' + row.id }">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="ml-4 d-inline"
                      v-has-permission="permission181"
                    ></vs-button>
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deletePost(row.id)"
                    class="d-inline"
                    v-has-permission="permission182"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
</style>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "Content_Managment_Posts_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      permission180: "CreatePost",
      permission181: "ModifyPost",
      permission182: "DeletePost",
      permission183: "ModifyCmsCategory|DeleteCategory|CreateCategory",
      permission184: "ModifyTag|DeleteTag|CreateTag",
      gridDataSource: {
        type: "app",
        service: "CMS/api/PostsQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  },
  methods: {
    ...mapActions({
      removePost: "post/remove"
    }),
    deletePost(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removePost(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  }
};
</script>
